function initBdImageCarousels() {
  const carousels = document.querySelectorAll("[data-bd-carousel]:not([data-bd-carousel-initialized])");
  carousels.forEach((root) => {
    root.setAttribute("data-bd-carousel-initialized", "true");
    initBdImageCarousel(root);
  });
}

function initBdImageCarousel(root) {
  const track = root.querySelector(".bd-image-carousel__track");
  const slides = Array.from(root.querySelectorAll(".bd-image-carousel__slide"));
  if (!track || slides.length < 2) return;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const prefersAutoplay = root.dataset.autoplay === "true";
  const autoplayEnabled = prefersAutoplay && !reducedMotion;
  const interval = Number.parseInt(root.dataset.interval, 10) || 4000;
  const pauseOnHover = root.dataset.pauseOnHover === "true";
  const transition = root.dataset.transition || "slide";

  const prevButton = root.querySelector("[data-carousel-prev]");
  const nextButton = root.querySelector("[data-carousel-next]");
  const dots = Array.from(root.querySelectorAll("[data-carousel-dot]"));
  const captions = Array.from(root.querySelectorAll("[data-carousel-caption]"));

  let currentIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
  if (currentIndex < 0) currentIndex = 0;

  let timer = null;
  let touchStartX = 0;
  let touchStartY = 0;

  const goTo = (index) => {
    const total = slides.length;
    currentIndex = ((index % total) + total) % total;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === currentIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    if (transition === "slide") {
      track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
    }

    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === currentIndex;
      dot.classList.toggle("is-active", isActive);
      dot.setAttribute("aria-selected", isActive ? "true" : "false");
      dot.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    captions.forEach((caption) => {
      const captionIndex = Number.parseInt(caption.dataset.carouselCaption, 10);
      const isActive = captionIndex === currentIndex;
      caption.classList.toggle("is-active", isActive);
      caption.hidden = !isActive;
    });
  };

  const next = () => goTo(currentIndex + 1);
  const prev = () => goTo(currentIndex - 1);

  const stopAutoplay = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  const startAutoplay = () => {
    stopAutoplay();
    if (!autoplayEnabled || slides.length < 2) return;
    timer = window.setInterval(next, interval);
  };

  if (transition === "slide") {
    track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
  }

  slides.forEach((slide, slideIndex) => {
    slide.setAttribute("aria-hidden", slideIndex === currentIndex ? "false" : "true");
  });

  if (prevButton) {
    prevButton.addEventListener("click", () => {
      prev();
      startAutoplay();
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", () => {
      next();
      startAutoplay();
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const targetIndex = Number.parseInt(dot.dataset.carouselDot, 10);
      if (Number.isNaN(targetIndex)) return;
      goTo(targetIndex);
      startAutoplay();
    });
  });

  const viewport = root.querySelector(".bd-image-carousel__viewport");
  if (viewport) {
    viewport.addEventListener(
      "touchstart",
      (event) => {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    viewport.addEventListener(
      "touchend",
      (event) => {
        if (!event.changedTouches.length) return;
        const deltaX = touchStartX - event.changedTouches[0].clientX;
        const deltaY = touchStartY - event.changedTouches[0].clientY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX > 0) next();
        else prev();
        startAutoplay();
      },
      { passive: true }
    );
  }

  if (pauseOnHover) {
    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);
  }

  root.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      prev();
      startAutoplay();
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      next();
      startAutoplay();
    }
  });

  startAutoplay();
}

document.addEventListener("DOMContentLoaded", initBdImageCarousels);
document.addEventListener("shopify:section:load", initBdImageCarousels);
